import { createAction, props } from '@ngrx/store';
import {
  Attribute,
  AttributeOption,
  AttributesListMeta,
  AttributeSubmitPayload,
  CreateGs1AttributePayload,
  ExportAttributesPayload,
  Gs1AiDefinition,
} from '../models/attribute.model';
import { ApiTableFilter } from '../../../shared/models/table-filter.model';

export const loadAttributes = createAction(
  '[Attributes] Load Attributes',
  props<{
    page?: number;
    perPage?: number;
    search?: string;
    sort?: string;
    sortDirection?: string;
    filters?: ApiTableFilter[];
    filterLink?: string;
  }>(),
);

export const loadAttributesSuccess = createAction(
  '[Attributes] Load Attributes Success',
  props<{ attributes: Attribute[]; meta: AttributesListMeta }>(),
);

export const loadAttributesFailure = createAction(
  '[Attributes] Load Attributes Failure',
  props<{ error: string }>(),
);

export const submitAttribute = createAction(
  '[Attributes] Submit Attribute',
  props<{ payload: AttributeSubmitPayload; isEditMode: boolean }>(),
);

export const submitAttributeSuccess = createAction(
  '[Attributes] Submit Attribute Success',
);

export const submitAttributeFailure = createAction(
  '[Attributes] Submit Attribute Failure',
  props<{ error: string }>(),
);

export const deleteAttribute = createAction(
  '[Attributes] Delete Attribute',
  props<{ attributeId: string }>(),
);

export const deleteAttributeSuccess = createAction(
  '[Attributes] Delete Attribute Success',
);

export const deleteAttributeFailure = createAction(
  '[Attributes] Delete Attribute Failure',
  props<{ error: string }>(),
);

export const exportAttributes = createAction(
  '[Attributes] Export Attributes',
  props<{ payload: ExportAttributesPayload }>(),
);

export const exportAttributesSuccess = createAction(
  '[Attributes] Export Attributes Success',
  props<{ jobId?: string | number }>(),
);

export const exportAttributesFailure = createAction(
  '[Attributes] Export Attributes Failure',
  props<{ error: string }>(),
);

export const loadGs1AiDefinitions = createAction(
  '[Attributes] Load GS1 AI Definitions',
);

export const loadGs1AiDefinitionsSuccess = createAction(
  '[Attributes] Load GS1 AI Definitions Success',
  props<{ definitions: Gs1AiDefinition[] }>(),
);

export const loadGs1AiDefinitionsFailure = createAction(
  '[Attributes] Load GS1 AI Definitions Failure',
  props<{ error: string }>(),
);

export const createGs1Attribute = createAction(
  '[Attributes] Create GS1 Attribute',
  props<{ payload: CreateGs1AttributePayload }>(),
);

export const createGs1AttributeSuccess = createAction(
  '[Attributes] Create GS1 Attribute Success',
);

export const createGs1AttributeFailure = createAction(
  '[Attributes] Create GS1 Attribute Failure',
  props<{ error: string }>(),
);

export const loadAttributeOptions = createAction(
  '[Attributes] Load Attribute Options',
  props<{ attributeId: string }>(),
);

export const loadAttributeOptionsSuccess = createAction(
  '[Attributes] Load Attribute Options Success',
  props<{ attributeId: string; options: AttributeOption[] }>(),
);

export const loadAttributeOptionsFailure = createAction(
  '[Attributes] Load Attribute Options Failure',
  props<{ error: string }>(),
);

export const clearAttributeOptions = createAction(
  '[Attributes] Clear Attribute Options',
);

export const resetAttributesState = createAction('[Attributes] Reset State');
